import { Deal, IGiftCardLine, IAffiliate } from '@poinz/api';

export const getFacebookUrlFromProfileId = (facebookId: string | number) => {
  const id = facebookId.toString();
  // It's a full url instead of id (mistake in CAMP)
  if (id.includes('http://') || id.includes('https://')) {
    return id;
  }
  return `https://www.facebook.com/${id}`;
};

export const getSocialLinks = (entity?: Deal | IGiftCardLine | IAffiliate) => {
  if (!entity) return null;

  return [
    ...(entity.url ? [{ key: 'general.footer.website', href: entity.url }] : []),
    ...(entity.facebookId
      ? [
          {
            key: 'general.footer.facebook',
            href: getFacebookUrlFromProfileId(entity.facebookId)
          }
        ]
      : []),
    ...(entity.twitterId ? [{ key: 'general.footer.twitter', href: entity.twitterId }] : []),
    ...(entity.instagramId ? [{ key: 'general.footer.instagram', href: entity.instagramId }] : [])
  ];
};
